
import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import styles from "./SelectMaterial.module.css";
import { FaTimes } from "react-icons/fa";

function SelectSearch({
  label,
  idProp = "id",
  labelProp = "name",
  options = [],
  placeholder = "Buscar...",
  onOptionSelect = () => {},
  disabled = false,
  errorMessage = "",
}) {
  const [searchValue, setSearchValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [showOptions, setShowOptions] = useState(false);

  const containerRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowOptions(false);
        setSelectedIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filterList = (value) => {
    const filtered = options.filter((option) =>
      (option[labelProp] || "").toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(filtered);
    setSelectedIndex(-1);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    filterList(value);
    setShowOptions(true);
  };

  const handleSelectOption = (option) => {
    setSearchValue(option[labelProp] || "");
    onOptionSelect(option);
    setShowOptions(false);
    setSelectedIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (!showOptions) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedIndex((prev) => Math.min(prev + 1, filteredOptions.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (selectedIndex >= 0 && selectedIndex < filteredOptions.length) {
        handleSelectOption(filteredOptions[selectedIndex]);
      }
    } else if (e.key === "Escape") {
      setShowOptions(false);
      setSelectedIndex(-1);
    }
  };

  const handleFocus = () => {
    if (searchValue) {
      filterList(searchValue);
    } else {
      setFilteredOptions(options);
    }
    setShowOptions(true);
  };

  const handleClear = () => {
    setSearchValue("");
    setFilteredOptions(options);
    setSelectedIndex(-1);
    setShowOptions(false);
    onOptionSelect(null);
  };

 
  return (
    <div className={styles.searchContainer} ref={containerRef}>
      <FaSearch className={styles.searchIcon} />
  
      <input
        ref={inputRef}
        type="text"
        className={styles.searchInput}
        placeholder={placeholder}
        disabled={disabled}
        value={searchValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
      />
  
  {searchValue && (
      <button
        className={`${styles.searchActionButton} ${styles.cancelButton}`}
        onClick={handleClear}
        disabled={disabled}
      >
        <FaTimes className={styles.buttonIcon} />
        Cancelar
      </button>
    )}
  
      {errorMessage && (
        <span className={styles.errorMessage}>{errorMessage}</span>
      )}
  
      {showOptions && filteredOptions.length > 0 && (
        <div className={styles.autocompleteSuggestions}>
          {filteredOptions.map((option, index) => (
            <div
              key={option[idProp] ?? index}
              className={`${styles.suggestionItem} ${
                selectedIndex === index ? styles.activeSuggestion : ""
              }`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelectOption(option)}
            >
              {option[labelProp]}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SelectSearch;
